import React from "react";
import { Link } from "react-router-dom";
import "../../styles/components/marketplace-shared.css";

const PrimaryActionLink = ({ to, children, className = "" }) => (
  <Link to={to} className={`marketplace-primary-cta ${className}`.trim()}>
    {children}
  </Link>
);

export default PrimaryActionLink;


